import { Heart } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const MissionSection = () => (
  <div className="about-mission">
    <div className="about-mission-content">
      <div className="mission-badge">
        <Heart size={20} />
        <span>Entreprise Familiale</span>
      </div>
      <h2 className="about-title">Notre Mission</h2>
      <p className="about-text">{companyInfo.mission}</p>
    </div>
    <div className="about-mission-image">
      <img 
        src="https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/wlmn6oy1_IMG_1242.JPG" 
        alt="Entreprise familiale - Lavage de Vitre Bois-Franc" 
        className="mission-family-image"
      />
    </div>
  </div>
);

export default MissionSection;
